import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import useTheme from '@hooks/use-theme';
import { StyledHero } from './styles';

export default function Hero() {
  const { isDark } = useTheme();
  return (
    <StyledHero>
      <section>
        <div className="hero-welcome">
          <h1>
            <span className="greeting">
              Hi there
              <span role="img" aria-label="Hand wave emoji">
                👋
              </span>{' '}
            </span>
            I'm a <span className="gatsby">Gatsby JS</span> static website
            template
          </h1>
          {
            //#region
          }
          <svg
            aria-hidden="true"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 850.538 740.8295"
          >
            <defs />
            <path
              d="M766.878 385.5395a354.2104 354.2104 0 01-98.85 245.9q-5.745 6.015-11.8 11.74-9.225 8.775-19.07 16.87a353.9342 353.9342 0 01-217.58 80.69q-3.975.09-7.98.09c-63.43 0-143.21-33.8799-215.61-80.78q-8.985-5.82-17.81-11.91-4.125-2.82-8.21-5.72a730.4296 730.4296 0 01-79.32-64.8 514.1163 514.1163 0 01-45.75-48.92c-55.63-68.62-67.9-130.45 11.41-143.16q14.085-2.25 27.34-4.81 19.2-3.69 36.75-7.97 23.64-5.745 44.42-12.46 6.99-2.25 13.66-4.59c65.74-23.09 109.74-53.2 139.69-85.87q7.62-8.295 14.05-16.79a236.0551 236.0551 0 0017.83-27.12 254.8984 254.8984 0 0018.41-41.05l.27-.78c23.83-68.74 16.58-132.5 42.87-153.84 112.38-91.23 252.29 38.69 317.96 191.9q4.965 11.58 9.34 23.3 1.965 5.2351 3.79 10.49 4.8 13.695 8.71 27.46 1.5 5.25 2.8601 10.49c.97 3.77 1.9 7.53 2.76 11.29 6.39 27.53 9.86 54.68 9.86 80.35z"
              fill="#f2f2f2"
            />
            <path
              d="M419.578 740.7396q-3.975.09-7.98.09c-63.43 0-143.21-33.88-215.61-80.78q-8.985-5.82-17.81-11.91l5.16-31.4 156.21-20.74 78.4 59.95z"
              fill="#2f2e41"
            />
            <path
              d="M427.098 180.0496h-22.26a2.601 2.601 0 00-2.5999 2.5999v22.27a2.5926 2.5926 0 002.5998 2.59h22.26a2.5992 2.5992 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.5999z"
              fill="#fff"
            />
            <path
              d="M427.098 217.9996h-22.26a2.601 2.601 0 00-2.5999 2.6v22.27a2.5925 2.5925 0 002.5998 2.59h22.26a2.599 2.599 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.6zM427.098 255.9495h-22.26a2.6012 2.6012 0 00-2.5999 2.6001v22.26a2.5946 2.5946 0 002.5998 2.5999h22.26a2.6012 2.6012 0 002.6001-2.5999v-22.26a2.6077 2.6077 0 00-2.6-2.6zM429.658 296.0396a2.6171 2.6171 0 00-2.56-2.1401h-22.26a2.6012 2.6012 0 00-2.5999 2.6v22.26a2.5947 2.5947 0 002.5998 2.6h22.26a2.6013 2.6013 0 002.6001-2.6v-22.26a2.3127 2.3127 0 00-.04-.4599zM428.108 332.0496a2.634 2.634 0 00-1.01-.2h-22.26a2.5947 2.5947 0 00-2.5998 2.6v22.26a2.5884 2.5884 0 002.5998 2.6h22.26a2.6014 2.6014 0 002.6001-2.6v-22.26a2.6157 2.6157 0 00-1.59-2.4zM473.858 180.0496h-22.26a2.601 2.601 0 00-2.5998 2.5999v22.27a2.5926 2.5926 0 002.5998 2.59h22.26a2.5992 2.5992 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.5999z"
              fill="#e6e6e6"
            />
            <path
              d="M473.858 217.9996h-22.26a2.601 2.601 0 00-2.5998 2.6v22.27a2.5925 2.5925 0 002.5998 2.59h22.26a2.599 2.599 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.6zM473.858 255.9495h-22.26a2.6012 2.6012 0 00-2.5998 2.6001v22.26a2.5946 2.5946 0 002.5998 2.5999h22.26a2.6012 2.6012 0 002.6001-2.5999v-22.26a2.6077 2.6077 0 00-2.6-2.6zM473.858 293.8995h-22.26a2.5926 2.5926 0 00-2.46 1.78 2.4785 2.4785 0 00-.1399.82v22.26a2.5947 2.5947 0 002.5999 2.6h22.26a2.6013 2.6013 0 002.6-2.6v-22.26a2.6078 2.6078 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M473.858 331.8495h-22.26a2.5947 2.5947 0 00-2.5998 2.6v22.26a2.5949 2.5949 0 002.5998 2.6001h22.26a2.6014 2.6014 0 002.6001-2.6v-22.26a2.6013 2.6013 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path
              d="M520.618 180.0496h-22.26a2.601 2.601 0 00-2.5998 2.5999v22.27a2.5926 2.5926 0 002.5998 2.59h22.26a2.5992 2.5992 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.5999zM520.618 217.9996h-22.26a2.601 2.601 0 00-2.5998 2.6v22.27a2.5925 2.5925 0 002.5998 2.59h22.26a2.599 2.599 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M520.618 255.9495h-22.26a2.6012 2.6012 0 00-2.5998 2.6001v22.26a2.5946 2.5946 0 002.5998 2.5999h22.26a2.6012 2.6012 0 002.6001-2.5999v-22.26a2.6077 2.6077 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path
              d="M520.618 293.8995h-22.26a2.6012 2.6012 0 00-2.5998 2.6v22.26a2.5947 2.5947 0 002.5998 2.6h22.26a2.6013 2.6013 0 002.6001-2.6v-22.26a2.6078 2.6078 0 00-2.6-2.6zM520.618 331.8495h-22.26a2.5947 2.5947 0 00-2.5998 2.6v22.26a2.5949 2.5949 0 002.5998 2.6001h22.26a2.6014 2.6014 0 002.6001-2.6v-22.26a2.6013 2.6013 0 00-2.6-2.6zM567.378 180.0496h-22.26a2.6011 2.6011 0 00-2.6 2.5999v22.27a2.5928 2.5928 0 002.6 2.59h22.26a2.5992 2.5992 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.5999z"
              fill="#6c63ff"
            />
            <path
              d="M567.378 217.9996h-22.26a2.6012 2.6012 0 00-2.6 2.6v22.27a2.5926 2.5926 0 002.6 2.59h22.26a2.599 2.599 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.6zM567.378 255.9495h-22.26a2.6013 2.6013 0 00-2.6 2.6001v22.26a2.5947 2.5947 0 002.6 2.5999h22.26a2.6012 2.6012 0 002.6001-2.5999v-22.26a2.6077 2.6077 0 00-2.6-2.6z"
              fill="#fff"
            />
            <path
              d="M567.378 293.8995h-22.26a2.6013 2.6013 0 00-2.6 2.6v22.26a2.5949 2.5949 0 002.6 2.6h22.26a2.6013 2.6013 0 002.6001-2.6v-22.26a2.6078 2.6078 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path
              d="M567.378 331.8495h-22.26a2.5949 2.5949 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6001h22.26a2.6014 2.6014 0 002.6001-2.6v-22.26a2.6013 2.6013 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M614.138 180.0496h-22.27a2.599 2.599 0 00-2.59 2.5999v22.27a2.5906 2.5906 0 002.59 2.59h22.27a2.5992 2.5992 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.5999zM614.138 217.9996h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.5905 2.5905 0 002.59 2.59h22.27a2.599 2.599 0 002.6001-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.6zM614.138 255.9495h-22.27a2.5991 2.5991 0 00-2.59 2.6001v22.26a2.5926 2.5926 0 002.59 2.5999h22.27a2.6012 2.6012 0 002.6001-2.5999v-22.26a2.6077 2.6077 0 00-2.6-2.6z"
              fill="#fff"
            />
            <path
              d="M614.138 293.8995h-22.27a2.5992 2.5992 0 00-2.59 2.6v22.26a2.5927 2.5927 0 002.59 2.6h22.27a2.6013 2.6013 0 002.6001-2.6v-22.26a2.6078 2.6078 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M614.138 331.8495h-22.27a2.5927 2.5927 0 00-2.59 2.6v22.26a2.5928 2.5928 0 002.59 2.6001h22.27a2.6014 2.6014 0 002.6001-2.6v-22.26a2.6013 2.6013 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path
              d="M660.898 180.0496h-22.27a2.599 2.599 0 00-2.59 2.5999v22.27a2.5906 2.5906 0 002.59 2.59h22.27a2.5993 2.5993 0 002.6001-2.59v-22.27a2.6077 2.6077 0 00-2.6-2.5999zM660.898 217.9996h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.5905 2.5905 0 002.59 2.59h22.27a2.5992 2.5992 0 002.6001-2.59v-22.27a2.6077 2.6077 0 00-2.6-2.6z"
              fill="#fff"
            />
            <path
              d="M660.898 255.9495h-22.27a2.5991 2.5991 0 00-2.59 2.6001v22.26a2.5926 2.5926 0 002.59 2.5999h22.27a2.6012 2.6012 0 002.6001-2.5999v-22.26a2.6078 2.6078 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M660.898 293.8995h-22.27a2.5992 2.5992 0 00-2.59 2.6v22.26a2.5927 2.5927 0 002.59 2.6h22.27a2.6013 2.6013 0 002.6001-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path
              d="M660.898 331.8495h-22.27a2.5927 2.5927 0 00-2.59 2.6v22.26a2.5928 2.5928 0 002.59 2.6001h22.27a2.6015 2.6015 0 002.6001-2.6v-22.26a2.6014 2.6014 0 00-2.6-2.6z"
              fill="#fff"
            />
            <path
              d="M707.658 180.0496h-22.27a2.599 2.599 0 00-2.59 2.5999v22.27a2.5906 2.5906 0 002.59 2.59h22.27a2.5993 2.5993 0 002.6001-2.59v-22.27a2.6077 2.6077 0 00-2.6-2.5999zM707.658 217.9996h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.5905 2.5905 0 002.59 2.59h22.27a2.5992 2.5992 0 002.6001-2.59v-22.27a2.6077 2.6077 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M707.658 255.9495h-22.27a2.5991 2.5991 0 00-2.59 2.6001v22.26a2.5926 2.5926 0 002.59 2.5999h22.27a2.6012 2.6012 0 002.6001-2.5999v-22.26a2.6078 2.6078 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path
              d="M707.658 293.8995h-22.27a2.5992 2.5992 0 00-2.59 2.6v22.26a2.5927 2.5927 0 002.59 2.6h22.27a2.6013 2.6013 0 002.6001-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
              fill="#fff"
            />
            <path
              d="M707.658 331.8495h-22.27a2.5927 2.5927 0 00-2.59 2.6v22.26a2.5928 2.5928 0 002.59 2.6001h22.27a2.6015 2.6015 0 002.6001-2.6v-22.26a2.6014 2.6014 0 00-2.6-2.6zM754.418 180.0496h-22.27a2.599 2.599 0 00-2.59 2.5999v22.27a2.5906 2.5906 0 002.59 2.59h22.27a2.5992 2.5992 0 002.6-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.5999zM754.418 217.9996h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.5905 2.5905 0 002.59 2.59h22.27a2.599 2.599 0 002.6-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M754.418 255.9495h-22.27a2.5991 2.5991 0 00-2.59 2.6001v22.26a2.5926 2.5926 0 002.59 2.5999h22.27a2.6011 2.6011 0 002.6-2.5999v-22.26a2.6077 2.6077 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path
              d="M754.418 293.8995h-22.27a2.5992 2.5992 0 00-2.59 2.6v22.26a2.5927 2.5927 0 002.59 2.6h22.27a2.6012 2.6012 0 002.6-2.6v-22.26a2.6078 2.6078 0 00-2.6-2.6zM754.418 331.8495h-22.27a2.5927 2.5927 0 00-2.59 2.6v22.26a2.5928 2.5928 0 002.59 2.6001h22.27a2.6014 2.6014 0 002.6-2.6v-22.26a2.6012 2.6012 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M801.178 180.0496h-22.27a2.599 2.599 0 00-2.59 2.5999v22.27a2.5906 2.5906 0 002.59 2.59h22.27a2.5992 2.5992 0 002.6-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.5999z"
              fill="#e6e6e6"
            />
            <path
              d="M801.178 217.9996h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.5905 2.5905 0 002.59 2.59h22.27a2.599 2.599 0 002.6-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.6zM801.178 255.9495h-22.27a2.5991 2.5991 0 00-2.59 2.6001v22.26a2.5926 2.5926 0 002.59 2.5999h22.27a2.6011 2.6011 0 002.6-2.5999v-22.26a2.6077 2.6077 0 00-2.6-2.6zM801.178 293.8995h-22.27a2.5992 2.5992 0 00-2.59 2.6v22.26a2.5927 2.5927 0 002.59 2.6h22.27a2.6012 2.6012 0 002.6-2.6v-22.26a2.6078 2.6078 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M801.178 331.8495h-22.27a2.5927 2.5927 0 00-2.59 2.6v22.26a2.5928 2.5928 0 002.59 2.6001h22.27a2.6014 2.6014 0 002.6-2.6v-22.26a2.6012 2.6012 0 00-2.6-2.6zM847.938 180.0496h-22.27a2.5991 2.5991 0 00-2.59 2.5999v22.27a2.5907 2.5907 0 002.59 2.59h22.27a2.5992 2.5992 0 002.6-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.5999zM847.938 217.9996h-22.27a2.5992 2.5992 0 00-2.59 2.6v22.27a2.5906 2.5906 0 002.59 2.59h22.27a2.599 2.599 0 002.6-2.59v-22.27a2.6076 2.6076 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path
              d="M847.938 255.9495h-22.27a2.5993 2.5993 0 00-2.59 2.6001v22.26a2.5927 2.5927 0 002.59 2.5999h22.27a2.6011 2.6011 0 002.6-2.5999v-22.26a2.6077 2.6077 0 00-2.6-2.6z"
              fill="#6c63ff"
            />
            <path
              d="M847.938 293.8995h-22.27a2.5993 2.5993 0 00-2.59 2.6v22.26a2.5928 2.5928 0 002.59 2.6h22.27a2.6012 2.6012 0 002.6-2.6v-22.26a2.6078 2.6078 0 00-2.6-2.6zM847.938 331.8495h-22.27a2.5928 2.5928 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6001h22.27a2.6014 2.6014 0 002.6-2.6v-22.26a2.6012 2.6012 0 00-2.6-2.6z"
              fill="#e6e6e6"
            />
            <path fill="#2f2e41" d="M336.095 660.051h-.62l.53-.07.09.07z" />
            <circle
              data-name="ab6171fa-7d69-4734-b81c-8dff60f9761b"
              cx="282.8144"
              cy="176.7328"
              r="68.3218"
              fill="#ffb6b6"
            />
            <path
              data-name="bf427902-b9bf-4946-b5d7-5c1c7e04535e"
              d="M342.646 126.6404s17.8693-34.161-21.4439-37.2665c0 0-33.5149-30.4023-67.6758-5.558 0 0-18.6332 0-28.8225 21.0856 0 0-14.655-5.558-17.8755 9.3166 0 0-10.7235 31.0555 0 59.0054 10.7234 27.9499 14.2853 31.0553 14.2853 31.0553s-17.6209-58.5983 25.27-61.704 90.8867-29.9094 94.461 4.2515 8.9534 42.5778 8.9534 42.5778 33.9496-48.7887-7.152-62.7637z"
              fill="#2f2e41"
            />
            <path
              d="M459.548 345.1096l-.22 1.16-2.47 13.04-17.07 90.2-1.01 5.31-2.12 11.23-2.9 15.32-6.4301 33.95-1.8399 9.73-.69 3.65-.24 1.28-1.91 10.07-.58 3.04-4.66 34.53-4.07 30.09 13.62 13.62-8.12 8.12-5.33 30.53.01.07h-217.53q-13.2-8.5501-26.02-17.6302l1.79-13.3999s6.16-23.93 3.57-26.79c-2.58-2.86-8.24-7.97-8.24-7.97l7.13-16.64.99-2.3099-1.66-34.43-.0399-.83-.55-11.3501-.07-1.46-.11-2.19-2.11-43.68-.04-.7201-.64-13.24-.6-12.5899-.26-5.31-2.57-53.13-1.74-36.08-1.52-31.41 6.11-2.07 65.3501-22.21 27.0698-35.19 56.3401.42 27.5801.21 46.02 42.68 10.47 5 .08.04 7.5099 3.59 19.04 9.09 20.1301 9.62 10.3298 4.93z"
              fill="#cacaca"
            />
            <path
              d="M269.1089 557.5509a30.2859 30.2859 0 01-40.664-22.43l-106.5587-15.118 37.0428-41.902 95.511 20.7804a30.45 30.45 0 0114.6689 58.6696z"
              fill="#ffb6b6"
            />
            <path
              d="M221.598 481.3696a13.5225 13.5225 0 00-7.89-4.87l-43.72-9.0901-4.49-.93a18.9327 18.9327 0 01-12.53-9.07 19.1606 19.1606 0 01-2.45-7.9 18.8946 18.8946 0 01.89-7.48l15.15-45.65 9.83-29.62a41.7921 41.7921 0 002.09-11.05 43.3488 43.3488 0 00-9.07-28.8898 42.6933 42.6933 0 00-49.01-13.6402c-.25.0901-.51.1901-.76.29a42.5832 42.5832 0 00-25.31 28.41l-10.68 38.85-22.03 80.0901a57.7664 57.7664 0 0048.96 72.68l62.97 7.38 29.14 3.42a13.4965 13.4965 0 0014.84-10.73 4.8954 4.8954 0 00.11-.55l.7-4.3202 5.93-36.3798.06-.3702a13.4748 13.4748 0 00-2.73-10.5798z"
              fill="#cacaca"
            />
            <path
              d="M336.9826 558.7171a30.286 30.286 0 0037.0945-27.9402l103.362-29.9936-42.5816-36.2596-91.6261 34.0415a30.45 30.45 0 00-6.2488 60.152z"
              fill="#ffb6b6"
            />
            <path
              d="M528.7581 433.6895L479.598 320.5496a42.819 42.819 0 00-20.27-21.35 43.3562 43.3562 0 00-8.7799-3.2c-.47-.12-.94-.23-1.41-.3201a42.1319 42.1319 0 00-19.48.36 42.8138 42.8138 0 00-27.34 21.73 1.0038 1.0038 0 00-.08.14 43.1003 43.1003 0 00-.37 38.85l.61 1.22 34.74 69.77a18.9005 18.9005 0 01-10.5 26.19l-2.44.8801-43.88 15.8499a13.4969 13.4969 0 00-8.33 16.79l.11.35 12.3 39.36c.06.18.1199.36.19.54a7.0543 7.0543 0 00.4.99 13.4818 13.4818 0 0015.8099 7.53l23.68-6.25 4.83-1.28 61.15-16.15a57.7604 57.7604 0 0038.22-78.86z"
              fill="#cacaca"
            />
            <path
              d="M44.898 528.6996a514.1163 514.1163 0 0045.75 48.92h451.97a16.4459 16.4459 0 0116.42 16.43l.65 114.53a355.4301 355.4301 0 0077.47-48.53q9.84-8.085 19.07-16.87 6.045-5.73 11.8-11.74a355.6285 355.6285 0 0068.82-102.74z"
              fill="#3f3d56"
            />
            <path
              d="M668.028 631.4395q-5.745 6.015-11.8 11.74h-96.21v-11.74z"
              fill="#fff"
            />
            <path
              d="M458.648 255.9495a5.5377 5.5377 0 00-4.87-2.8999h-327.84a5.5545 5.5545 0 00-5.54 5.55v196.22h338.93v-196.22a5.3855 5.3855 0 00-.68-2.65z"
              fill="#3f3d56"
            />
            <path
              d="M120.1011 449.5072v24.2138a7.6438 7.6438 0 007.6439 7.6439h125.0967v47.7866h-1.6619a.9929.9929 0 00-.993.9929v3.3237a.9929.9929 0 00.993.993h77.6584a.993.993 0 00.993-.993v-3.3237a.9929.9929 0 00-.993-.993h-1.6618V481.365H452.273a7.6438 7.6438 0 007.6438-7.644v-24.2137z"
              fill="#3f3d56"
            />
            <circle cx="285.9029" cy="348.7037" r="31.3064" fill="#6c63ff" />
            <path
              d="M365.668 172.9996h-5c0-37.8-37.41-62.57-75.15-62.59a82.3823 82.3823 0 00-16.35 1.59c-6.06 1.21-12.35 2.66-18.53 4.55-24.37 7.47-46.97 21.91-46.97 56.45a78.591 78.591 0 002.54 19.88l-4.84 1.26a83.8757 83.8757 0 01-2.7-21.14c0-30.18 12.39-50.91 33.79-63.27 11.25-6.5 24.98-10.69 40.71-12.73a97.1308 97.1308 0 0119.75-.6c43.4 3.12 72.75 36.4 72.75 76.6z"
              fill="#6c63ff"
            />
            <path
              d="M373.998 175.7695l-1.97-14.56a15.7101 15.7101 0 00-5-9.56 15.8157 15.8157 0 00-13.25-4l-3.13.43a6.5243 6.5243 0 00-4.35 2.53 6.548 6.548 0 00-1.29 4.87l4.55 33.54a6.5771 6.5771 0 005.3 5.57 6.1544 6.1544 0 001.22.12 6.4988 6.4988 0 00.88-.06l3.5-.47a15.7913 15.7913 0 0010.74-6.43c.27-.38.53-.77.77-1.17a16.7484 16.7484 0 002.03-10.81z"
              fill="#6c63ff"
            />
            <path
              d="M348.628 148.6896a6.4317 6.4317 0 00-2.33 1.92 6.548 6.548 0 00-1.29 4.87l4.55 33.54a6.5771 6.5771 0 005.3 5.57z"
              fill="#fff"
            />
            <path
              d="M373.998 175.7695l-1.97-14.56a15.7101 15.7101 0 00-5-9.56l4.53 33.37a6.176 6.176 0 00.41 1.56 16.7484 16.7484 0 002.03-10.81z"
              fill="#3f3d56"
            />
            <ellipse
              cx="532.2183"
              cy="258.909"
              rx="2.5"
              ry="7"
              transform="rotate(-7.726 -144.4933 1513.0377)"
              fill="#3f3d56"
            />
            <ellipse
              cx="529.2183"
              cy="240.909"
              rx="2.5"
              ry="7"
              transform="rotate(-7.726 -147.4932 1495.0377)"
              fill="#3f3d56"
            />
            <ellipse
              cx="548.2183"
              cy="247.909"
              rx="2.5"
              ry="7"
              transform="rotate(-7.726 -128.4932 1502.0377)"
              fill="#3f3d56"
            />
            <path
              d="M285.518 110.4095a82.3823 82.3823 0 00-16.35 1.59c-6.06 1.21-12.35 2.66-18.53 4.55-9.65-.47-16.75-2.97-18.18-6.82 11.25-6.5 24.98-10.69 40.71-12.73a97.1308 97.1308 0 0119.75-.6 5.727 5.727 0 012.72 3.82c.47 3.48-3.5 7.18-10.12 10.19z"
              fill="#3f3d56"
            />
            <path
              d="M221.678 207.6996l-7.7-32.01a6.0237 6.0237 0 00-4.88-4.55 6.7333 6.7333 0 00-1-.08 6.0258 6.0258 0 00-1.4.17l-2.98.72a14.904 14.904 0 00-10.99 17.96l3.45 14.36a15.845 15.845 0 005.34 8.62 14.045 14.045 0 001.36.97 14.8092 14.8092 0 0011.37 1.84l2.97-.72a5.8401 5.8401 0 002.17-1.01 5.9933 5.9933 0 002.29-6.27z"
              fill="#6c63ff"
            />
            <ellipse
              cx="378.629"
              cy="274.5232"
              rx="2.5"
              ry="7"
              transform="rotate(-13.53 -44.1774 971.198)"
              fill="#3f3d56"
            />
            <ellipse
              cx="368.629"
              cy="277.5232"
              rx="2.5"
              ry="7"
              transform="rotate(-13.53 -54.1774 974.198)"
              fill="#3f3d56"
            />
            <path
              d="M222.168 207.5795l-7.7-32.01a6.5317 6.5317 0 00-5.29-4.92l10.51 43.72a6.5111 6.5111 0 002.48-6.79z"
              fill="#fff"
            />
            <path
              d="M194.468 183.5696a6.476 6.476 0 00-1.17-2.45 14.7255 14.7255 0 00-.57 8.79l3.45 14.36a15.845 15.845 0 005.34 8.62z"
              fill="#3f3d56"
            />
          </svg>
          {
            //#endregion
          }
        </div>
        <h2>
          I come pre-packed with Emotion and Tailwind CSS for styling
          components. I support cool modern features like lazy-loading images,
          code and data splitting, and offline support. Check out the source
          code{' '}
          <a
            href="https://github.com/chrismwilliams/gatsby-emotion-tailwind-starter"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>{' '}
          and go build something cool! <span>{isDark ? '😍' : '😎'}</span>
        </h2>
        <ul className="tech">
          <li>
            <svg role="img" focusable="false" viewBox="0 0 106 30">
              <title>Gatsby JS logo</title>
              <g fill="currentColor">
                <path d="M62.9,12h2.8v10h-2.8v-1.3c-1,1.5-2.3,1.6-3.1,1.6c-3.1,0-5.1-2.4-5.1-5.3c0-3,2-5.3,4.9-5.3c0.8,0,2.3,0.1,3.2,1.6V12z M57.7,17c0,1.6,1.1,2.8,2.8,2.8c1.6,0,2.8-1.2,2.8-2.8c0-1.6-1.1-2.8-2.8-2.8C58.9,14.2,57.7,15.4,57.7,17z"></path>
                <path d="M71.2,14.4V22h-2.8v-7.6h-1.1V12h1.1V8.6h2.8V12h1.9v2.4H71.2z"></path>
                <path d="M79.7,14.4c-0.7-0.6-1.3-0.7-1.6-0.7c-0.7,0-1.1,0.3-1.1,0.8c0,0.3,0.1,0.6,0.9,0.9l0.7,0.2c0.8,0.3,2,0.6,2.5,1.4 c0.3,0.4,0.5,1,0.5,1.7c0,0.9-0.3,1.8-1.1,2.5c-0.8,0.7-1.8,1.1-3,1.1c-2.1,0-3.2-1-3.9-1.7l1.5-1.7c0.6,0.6,1.4,1.2,2.2,1.2 c0.8,0,1.4-0.4,1.4-1.1c0-0.6-0.5-0.9-0.9-1l-0.6-0.2c-0.7-0.3-1.5-0.6-2.1-1.2c-0.5-0.5-0.8-1.1-0.8-1.9c0-1,0.5-1.8,1-2.3 c0.8-0.6,1.8-0.7,2.6-0.7c0.7,0,1.9,0.1,3.2,1.1L79.7,14.4z"></path>
                <path d="M85.8,13.3c1-1.4,2.4-1.6,3.2-1.6c2.9,0,4.9,2.3,4.9,5.3c0,3-2,5.3-5,5.3c-0.6,0-2.1-0.1-3.2-1.6V22H83V5.2h2.8V13.3z M85.5,17c0,1.6,1.1,2.8,2.8,2.8c1.6,0,2.8-1.2,2.8-2.8c0-1.6-1.1-2.8-2.8-2.8C86.6,14.2,85.5,15.4,85.5,17z"></path>
                <path d="M98.5,20.5L93.7,12H97l3.1,5.7l2.8-5.7h3.2l-8,15.3h-3.2L98.5,20.5z"></path>
                <path d="M54,13.7h-2.8c0,0-4.2,0-4.2,0v2.8h3.7c-0.6,1.9-2,3.2-4.6,3.2c-2.9,0-5-2.4-5-5.3S43.1,9,46,9c1.6,0,3.2,0.8,4.2,2.1 l2.3-1.5C51,7.5,48.6,6.3,46,6.3c-4.4,0-8,3.6-8,8.1s3.4,8.1,8,8.1s8-3.6,8-8.1C54.1,14.1,54,13.9,54,13.7z"></path>
              </g>
              <g>
                <g fill="#ffffff">
                  <path d="M25,14h-7v2h4.8c-0.7,3-2.9,5.5-5.8,6.5L5.5,11c1.2-3.5,4.6-6,8.5-6c3,0,5.7,1.5,7.4,3.8l1.5-1.3 C20.9,4.8,17.7,3,14,3C8.8,3,4.4,6.7,3.3,11.6l13.2,13.2C21.3,23.6,25,19.2,25,14z"></path>
                  <path d="M3,14.1c0,2.8,1.1,5.5,3.2,7.6c2.1,2.1,4.9,3.2,7.6,3.2L3,14.1z"></path>
                </g>
                <path
                  d="M14,0C6.3,0,0,6.3,0,14s6.3,14,14,14s14-6.3,14-14S21.7,0,14,0z M6.2,21.8c-2.1-2.1-3.2-4.9-3.2-7.6L13.9,25 C11.1,24.9,8.3,23.9,6.2,21.8z M16.4,24.7L3.3,11.6C4.4,6.7,8.8,3,14,3c3.7,0,6.9,1.8,8.9,4.5l-1.5,1.3C19.7,6.5,17,5,14,5 c-3.9,0-7.2,2.5-8.5,6L17,22.5c2.9-1,5.1-3.5,5.8-6.5H18v-2h7C25,19.2,21.3,23.6,16.4,24.7z"
                  fill="#663399"
                ></path>
              </g>
            </svg>
          </li>
          <li>
            <StaticImage
              src="../../images/emotion.png"
              placeholder="blurred"
              alt="Emotion CSS in JS Logo"
            />
          </li>
          <li>
            <svg role="img" focusable="false" viewBox="0 0 248 31">
              <title>Tailwind CSS logo</title>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.517 0C18.712 0 14.46 3.382 12.758 10.146c2.552-3.382 5.529-4.65 8.931-3.805 1.941.482 3.329 1.882 4.864 3.432 2.502 2.524 5.398 5.445 11.722 5.445 6.804 0 11.057-3.382 12.758-10.145-2.551 3.382-5.528 4.65-8.93 3.804-1.942-.482-3.33-1.882-4.865-3.431C34.736 2.92 31.841 0 25.517 0zM12.758 15.218C5.954 15.218 1.701 18.6 0 25.364c2.552-3.382 5.529-4.65 8.93-3.805 1.942.482 3.33 1.882 4.865 3.432 2.502 2.524 5.397 5.445 11.722 5.445 6.804 0 11.057-3.381 12.758-10.145-2.552 3.382-5.529 4.65-8.931 3.805-1.941-.483-3.329-1.883-4.864-3.432-2.502-2.524-5.398-5.446-11.722-5.446z"
                fill="#06B6D4"
              ></path>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M76.546 12.825h-4.453v8.567c0 2.285 1.508 2.249 4.453 2.106v3.463c-5.962.714-8.332-.928-8.332-5.569v-8.567H64.91V9.112h3.304V4.318l3.879-1.143v5.937h4.453v3.713zM93.52 9.112h3.878v17.849h-3.878v-2.57c-1.365 1.891-3.484 3.034-6.285 3.034-4.884 0-8.942-4.105-8.942-9.389 0-5.318 4.058-9.388 8.942-9.388 2.801 0 4.92 1.142 6.285 2.999V9.112zm-5.674 14.636c3.232 0 5.674-2.392 5.674-5.712s-2.442-5.711-5.674-5.711-5.674 2.392-5.674 5.711c0 3.32 2.442 5.712 5.674 5.712zm16.016-17.313c-1.364 0-2.477-1.142-2.477-2.463a2.475 2.475 0 012.477-2.463 2.475 2.475 0 012.478 2.463c0 1.32-1.113 2.463-2.478 2.463zm-1.939 20.526V9.112h3.879v17.849h-3.879zm8.368 0V.9h3.878v26.06h-3.878zm29.053-17.849h4.094l-5.638 17.849h-3.807l-3.735-12.03-3.771 12.03h-3.806l-5.639-17.849h4.094l3.484 12.315 3.771-12.315h3.699l3.734 12.315 3.52-12.315zm8.906-2.677c-1.365 0-2.478-1.142-2.478-2.463a2.475 2.475 0 012.478-2.463 2.475 2.475 0 012.478 2.463c0 1.32-1.113 2.463-2.478 2.463zm-1.939 20.526V9.112h3.878v17.849h-3.878zm17.812-18.313c4.022 0 6.895 2.713 6.895 7.354V26.96h-3.878V16.394c0-2.713-1.58-4.14-4.022-4.14-2.55 0-4.561 1.499-4.561 5.14v9.567h-3.879V9.112h3.879v2.285c1.185-1.856 3.124-2.749 5.566-2.749zm25.282-6.675h3.879V26.96h-3.879v-2.57c-1.364 1.892-3.483 3.034-6.284 3.034-4.884 0-8.942-4.105-8.942-9.389 0-5.318 4.058-9.388 8.942-9.388 2.801 0 4.92 1.142 6.284 2.999V1.973zm-5.674 21.775c3.232 0 5.674-2.392 5.674-5.712s-2.442-5.711-5.674-5.711-5.674 2.392-5.674 5.711c0 3.32 2.442 5.712 5.674 5.712zm22.553 3.677c-5.423 0-9.481-4.105-9.481-9.389 0-5.318 4.058-9.388 9.481-9.388 3.519 0 6.572 1.82 8.008 4.605l-3.34 1.928c-.79-1.678-2.549-2.749-4.704-2.749-3.16 0-5.566 2.392-5.566 5.604 0 3.213 2.406 5.605 5.566 5.605 2.155 0 3.914-1.107 4.776-2.749l3.34 1.892c-1.508 2.82-4.561 4.64-8.08 4.64zm14.472-13.387c0 3.249 9.661 1.285 9.661 7.89 0 3.57-3.125 5.497-7.003 5.497-3.591 0-6.177-1.607-7.326-4.177l3.34-1.927c.574 1.606 2.011 2.57 3.986 2.57 1.724 0 3.052-.571 3.052-2 0-3.176-9.66-1.391-9.66-7.781 0-3.356 2.909-5.462 6.572-5.462 2.945 0 5.387 1.357 6.644 3.713l-3.268 1.82c-.647-1.392-1.904-2.035-3.376-2.035-1.401 0-2.622.607-2.622 1.892zm16.556 0c0 3.249 9.66 1.285 9.66 7.89 0 3.57-3.124 5.497-7.003 5.497-3.591 0-6.176-1.607-7.326-4.177l3.34-1.927c.575 1.606 2.011 2.57 3.986 2.57 1.724 0 3.053-.571 3.053-2 0-3.176-9.66-1.391-9.66-7.781 0-3.356 2.908-5.462 6.572-5.462 2.944 0 5.386 1.357 6.643 3.713l-3.268 1.82c-.646-1.392-1.903-2.035-3.375-2.035-1.401 0-2.622.607-2.622 1.892z"
                fill="currentColor"
              ></path>
            </svg>
          </li>
        </ul>
      </section>
    </StyledHero>
  );
}
